export interface DynRule {
  operator: string;
  condition_field: string;
  condition: string;
  value: string;
}

export interface DynRuleSet {
  operator?: string;
  rules: DynRule[];
}

export interface GroupLoSelection {
  id: number;
  type: string;
}

export interface DynamicGroupWizardData {
  name: string;
  description: string;
  sets: DynRuleSet[];
  loSelections: GroupLoSelection[];
  enrollType: string;
}

export const INITIAL_DYNAMIC_GROUP_DATA: DynamicGroupWizardData = {
  name: "",
  description: "",
  sets: [{ operator: "AND", rules: [] }],
  loSelections: [],
  enrollType: "TOP",
};

export const buildRuleOperator = (
  logic: "AND" | "OR",
  exclude: boolean,
): string => `${logic}${exclude ? "_NOT" : ""}`;

export const parseRuleOperator = (
  operator: string,
): { logic: "AND" | "OR"; exclude: boolean } => ({
  logic: operator?.startsWith("OR") ? "OR" : "AND",
  exclude: !!operator?.endsWith("_NOT"),
});
